export default __webpack_public_path__ + "static/media/logo-100.db2da8f8.png";